<section class="custom-modal" role="dialog" aria-modal="true" aria-labelledby="add-user-modal-title">
  @if (isLoading) {
    <div class="loading-overlay">
      <app-shared-loading-g [animation]="animation"></app-shared-loading-g>
    </div>
  }

  <header class="modal-header">
    <div class="modal-header-text">
      <h2 id="add-user-modal-title" class="modal-title">{{ modalTitle }}</h2>
      @if (modalSubtitle) {
        <p class="modal-subtitle">{{ modalSubtitle }}</p>
      }
    </div>
    <button type="button" class="icon-button" aria-label="Close" (click)="onCancel()">
      <app-display-icon [border]="false" [colour]="iconColourEnum.primary" [icon]="icon.close">
      </app-display-icon>
    </button>
  </header>

  <div class="modal-body">
    @if (newUser) {
      <div [formGroup]="userForm" class="form-section">
        <label class="form-label" for="add-user-email">Email</label>
        <input
          id="add-user-email"
          class="form-input"
          formControlName="email"
          placeholder="Enter email"
          type="email"
          [class.form-input--error]="isEmailFieldInvalid()"
          (blur)="onEmailBlur()">
        @if (isEmailFieldInvalid()) {
          <span class="field-error">{{ getEmailErrorMessage() }}</span>
        } @else {
          <p class="hint-text">The user will receive a password reset email. You can copy its reset link after creating them.</p>
        }
      </div>
    } @else {
      <div [formGroup]="userForm" class="form-section">
        <app-shared-custom-search
          class="search-bar"
          [searchAll]="userForm.controls.search.value"
          [placeholder]="'Search…'"
          (searchChange)="onSearchChange($event)">
        </app-shared-custom-search>
      </div>
    }

    <p class="section-label">Select {{ entryLabel }} and group access</p>

    @if (hasAvailableEntries) {
        <div class="entry-list">
          @for (entryId of filteredStoreIds; track entryId) {
            @if (!selectedEntries?.includes(entryId)) {
              <div class="entry-card" [class.entry-card-disabled]="getAvailableSpace(entryId) < 1">
                <label class="entry-main">
                  <input
                    type="checkbox"
                    class="entry-checkbox"
                    [checked]="adminStoreIdsWithSelected[entryId].selected"
                    [disabled]="getAvailableSpace(entryId) < 1"
                    (change)="onStoreSelect(entryId)">
                  <span class="entry-name">
                    <span class="entry-name-primary">
                      {{ getEntryDisplayName(entryId) }}
                      @if (getAvailableSpace(entryId) < 1) {
                        <span class="entry-name-muted"> is full</span>
                      }
                    </span>
                    @if (getEntrySecondaryLabel(entryId)) {
                      <span class="entry-name-secondary">{{ getEntrySecondaryLabel(entryId) }}</span>
                    }
                  </span>
                </label>

                @if (isRowRoleControlsVisible(entryId)) {
                  <div class="entry-role-row">
                    <app-shared-custom-select
                      (selectionChange)="onRoleSelectChange(entryId, $event)"
                      [allowMultiple]="false"
                      [allowSelectAll]="false"
                      [autoSubmitOnSelect]="true"
                      [floatDropdown]="true"
                      [keyOrder]="roleKeyOrder"
                      [placeholder]="'Select role'"
                      [setOptions]="roleOptionsByEntry[entryId]"
                      [showActionButtons]="false"
                      [showChips]="false"
                      [showSearchBar]="false">
                    </app-shared-custom-select>
                    <button
                      type="button"
                      class="icon-action-button"
                      [attr.title]="isAdminRole(entryId) ? adminPermissionsTooltip : 'Customise permissions'"
                      [matTooltip]="isAdminRole(entryId) ? adminPermissionsTooltip : ''"
                      [disabled]="isAdminRole(entryId)"
                      (click)="onCustomisePermissionsClick(entryId)">
                      <app-display-icon
                        [border]="false"
                        [colour]="iconColourEnum.primary"
                        [icon]="icon.pencil">
                      </app-display-icon>
                    </button>
                  </div>
                }
              </div>
            }
          }
        </div>
    } @else {
      <p class="empty-message">
        There are no available {{ entryLabel | lowercase }} for this {{ newUser ? 'user' : (!editingUserId ? 'store' : 'user') }}.
      </p>
    }
  </div>

  <footer class="modal-footer">
    <app-shared-button [colour]="'primary'" [disabled]="isLoading" (click)="onCancel()">Cancel</app-shared-button>
    <app-shared-button
      [colour]="'primary'"
      [disabled]="isSubmitDisabled"
      [fill]="true"
      (buttonClicked)="onSubmit()">
      {{ submitLabel }}
    </app-shared-button>
  </footer>
</section>
